export const LIVE_STREAMING_MODULE = {
  STRIP_COLOR_MODE: {
    light: 'light',
    dark: 'dark'
  },

  ACTION_TYPES: {
    onButtonClickEvent: 'onButtonClickEvent',
    onDisplayEvent: 'onDisplayEvent'
  },

  LOGO: {
    MOBILE_SIZES: {
      width: 48,
      height: 12
    },

    DESKTOP_SIZES: {
      width: 78,
      height: 20
    },
  },
};